import { styled } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

export const CheckboxFieldRoot = styled(FormControlLabel)`
  margin: 0;
`;
